import {
	Button,
	Checkbox,
	FormControlLabel,
	IconButton,
	MenuItem,
	Modal,
	Paper,
	Radio,
	RadioGroup,
	Select,
	TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { QuestType } from "../Enums/Test";

import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import { Answer, Question } from "../interfaces/Test";

interface IProps {
	open: boolean;
	onClose(quest?: Question, edit?: boolean): void;
	quest?: Question;
}

const CreateQuestModal = (props: IProps) => {
	const [questType, setquestType] = useState<QuestType>(QuestType.single);
	const [answerName, setAnswerName] = useState<string>("");
	const [questName, setQuestName] = useState<string>("");
	const [answers, setAnswers] = useState<Answer[]>([]);

	const [correctAnswers, setCorrectAnswers] = useState<any[]>([]);

	const clearModal = () => {
		setAnswerName("");
		setQuestName("");
		setAnswers([]);
		setCorrectAnswers([]);
	};

	const validate = () => {
		if (correctAnswers.length > 0 && questName) return false;
		return true;
	};

	useEffect(() => {
		if (props.quest) {
			setquestType(props.quest.type);
			setQuestName(props.quest.title);
			setAnswers(props.quest.answers);
			setCorrectAnswers(props.quest.correct_answers);
		} else {
			clearModal();
		}
	}, [props.quest]);

	useEffect(() => {
		var result: any[] = [];

		answers.forEach((a) => {
			if (a.succes) result.push(a.id);
		});
		setCorrectAnswers([...result]);
	}, [answers]);

	return (
		<Modal
			open={props.open}
			onClose={() => {
				props.onClose();
			}}
			className="flex items-center flex-col overflow-auto py-10"
		>
			<Paper className="focus-visible:outline-none p-5 max-w-[900px]  flex flex-col gap-5 ">
				<div className="flex flex-col gap-4">
					<TextField
						label="Вопрос"
						value={questName}
						onChange={(ev) => {
							setQuestName(ev.target.value);
						}}
					/>
					<Select
						label="Тип"
						value={questType}
						onChange={(ev) => {
							setAnswers([]);
							setquestType(ev.target.value as QuestType);
						}}
					>
						<MenuItem selected value={QuestType.single}>
							Одиночный
						</MenuItem>
						<MenuItem value={QuestType.multiple}>Множественный</MenuItem>
						<MenuItem value={QuestType.text}>Текст</MenuItem>
					</Select>
					<div className="mt-2">
						<div className="flex-col">
							{questType == QuestType.single ? (
								<RadioGroup>
									{answers.map((a) => (
										<div className="flex gap-2">
											<IconButton
												color="error"
												onClick={() => {
													setAnswers((answ) => {
														answ.splice(a.id, 1);
														answ.map((ans, i: any) => {
															ans.id = i as number;
														});
														return [...answ];
													});
												}}
											>
												<DeleteIcon />
											</IconButton>

											<FormControlLabel
												value={a.id}
												control={
													<Radio
														checked={correctAnswers.includes(a.id)}
														onChange={(ev) => {
															setAnswers((ans) => {
																ans[a.id].succes = ev.target.checked;
																return [...ans];
															});
														}}
													/>
												}
												label={a.text}
											/>
										</div>
									))}
								</RadioGroup>
							) : questType == QuestType.multiple ? (
								answers.map((a) => (
									<div className="flex gap-2">
										<IconButton
											color="error"
											onClick={() => {
												setAnswers((answ) => {
													answ.splice(a.id, 1);
													answ.map((ans, i: any) => {
														ans.id = i as number;
													});
													return [...answ];
												});
											}}
										>
											<DeleteIcon />
										</IconButton>
										<FormControlLabel
											label={a.text}
											control={
												<Checkbox
													checked={correctAnswers.includes(a.id)}
													onChange={(ev) => {
														setAnswers((ans) => {
															ans[a.id].succes = ev.target.checked;
															return [...ans];
														});
													}}
												/>
											}
										/>
									</div>
								))
							) : (
								<TextField
									multiline
									placeholder="Правильный ответ"
									onChange={(ev) => {
										setCorrectAnswers([ev.target.value]);
									}}
								/>
							)}
							{questType != QuestType.text ? (
								<div className="flex items-center">
									<TextField
										label="Ответ"
										variant="standard"
										value={answerName}
										onChange={(ev) => {
											setAnswerName(ev.target.value);
										}}
									/>
									<IconButton
										color="primary"
										disabled={!answerName}
										onClick={() => {
											setAnswers((a) => {
												const answer: Answer = {
													id: a.length,
													text: answerName,
												};
												return [...a, answer];
											});
											setAnswerName("");
										}}
									>
										<AddCircleIcon />
									</IconButton>
								</div>
							) : null}
						</div>
						<Button
							disabled={validate()}
							className="!mt-5 w-full"
							onClick={() => {
								const quest: Question = {
									title: questName,
									type: questType,
									answers: answers,
									correct_answers: correctAnswers,
								};
								props.onClose(quest, props.quest != undefined);
								clearModal();
							}}
						>
							Сохранить
						</Button>
					</div>
				</div>
			</Paper>
		</Modal>
	);
};

export default CreateQuestModal;
